import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { TEAM_KEY, TeamResponse, TeamUpdate, updateTeam } from '@utils/backend-api/teams';

import useCurrentUser from './useCurrentUser';

export default function useTeamUpdate() {
  const queryClient = useQueryClient();
  const { currentUser } = useCurrentUser();
  const { data, mutate, mutateAsync, isLoading } = useMutation(
    (values: TeamUpdate) => updateTeam(values),
    {
      onSuccess: (data: TeamResponse) => {
        if (data.success) {
          toast.success('Team settings have been updated.');
        }
        queryClient.setQueryData([TEAM_KEY, currentUser.guid], data);
      },
      onError: () => {
        toast.error('Team was not saved, please try again.');
      },
    }
  );

  return {
    updateTeamData: data,
    updateTeam: mutate,
    updateTeamAsync: mutateAsync,
    isTeamUpdateLoading: isLoading,
  };
}
